import React from 'react';
import Avatar from '@mui/material/Avatar';
import DateRangeTwoToneIcon from '@mui/icons-material/DateRangeTwoTone';
import Stack from '@mui/material/Stack';
import { SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

export interface Props {
  createdByName: string,
  createdOn: string,
  createdByAvatar?: string,
  verb?: string,
  sx?: SxProps<Theme>,
}

function capitalize([first, ...rest]: string): string {
  return [first.toUpperCase(), ...rest].join('');
}

const CombinedCreatedField: React.FC<Props> = ({
  createdByName,
  createdOn,
  createdByAvatar = ' ',
  verb = 'created',
  sx = {},
}: Props) => {
  const safeVerb = verb.length > 2 ? verb : 'created';
  const userLabel = `${capitalize(safeVerb)} by`;
  const dateLabel = `Date ${safeVerb.toLowerCase()}`;
  return (
    <Stack direction="row" spacing={3} alignItems="center" sx={{ fontSize: '14px', whiteSpace: 'nowrap', ...sx }}>
      <Stack direction="row" spacing={1}>
        <Typography sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{userLabel}</Typography>
        <Avatar alt={createdByName} src={createdByAvatar} sx={{ width: 24, height: 24 }} />
        <Typography noWrap sx={{ maxWidth: 140 }}>{createdByName}</Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Typography sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{dateLabel}</Typography>
        <Avatar sx={{
          bgcolor: '#E0E0E0', width: 24, height: 24, color: 'rgba(0, 0, 0, 0.54)',
        }}
        >
          <DateRangeTwoToneIcon sx={{ width: 18, height: 18 }} />
        </Avatar>
        <Typography>{createdOn}</Typography>
      </Stack>
    </Stack>
  );
};

export default CombinedCreatedField;
